import * as React from 'react'

import { observer } from 'mobx-react'

import type { IncidenceRules } from 'modules/bookkeepers/store/collections/incidenceRules'

export interface ContractCues {
  hasCues: boolean
  incidenceRules: IncidenceRules
  listOfFields: Map<string, (string | undefined)[]>
}

const Context = React.createContext<ContractCues | null>(null)

export const ContractCuesProvider = observer(
  ({ collection, children }: { collection: ContractCues; children: React.ReactNode }) => {
    return <Context.Provider value={collection}>{children}</Context.Provider>
  }
)

export const useContractCues = (): ContractCues => {
  const contractCues = React.useContext(Context)

  if (!contractCues) {
    throw new Error('useContractCues must be used within a ContractCuesProvider')
  }

  return contractCues
}
